import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  Input,
  OnChanges,
} from "@angular/core";
import { BacDashboardInformation } from "../../../../core/models/dashboard-poc/bacDashboardInformation";
import { ChartModule } from "primeng/chart";
import { SharedService } from "../../../../core/services/shared.service";

@Component({
  selector: "jni-support-map-pie-chart",
  templateUrl: "./support-map-pie-chart.component.html",
  styleUrls: ["./support-map-pie-chart.component.scss"],
  imports: [ChartModule],
})
export class SupportMapPieChartComponent implements OnChanges {
  bgColor = "";
  textColor = "";
  private sharedService = inject(SharedService);

  constructor(private cd: ChangeDetectorRef) {
    effect(() => {
      const currentTheme = this.sharedService.getTheme()();
      this.bgColor = currentTheme === "dark" ? "#212630" : "#FFFFFF";
      this.mapChart();
      // const documentStyle = getComputedStyle(document.documentElement);
      // this.textColor = documentStyle.getPropertyValue("--p-h2color-color");
      // this.options.plugins.legend.labels.color = this.textColor;
      // this.updateChartOptions();
    });
  }
  @Input()
  bacDashboardInformation!: BacDashboardInformation[];
  data!: {
    labels: string[];
    datasets: {
      label?: string;
      backgroundColor?: string | string[];
      borderColor?: string;
      hoverBackgroundColor?: string | string[];
      data?: number[];
      type?: string;
      borderWidth?: number;
      fill?: boolean;
      tension?: number;
    }[];
  };
  options!: {
    plugins: {
      legend: {
        labels: {
          usePointStyle: boolean;
          color: string;
        };
      };
    };
  };

  mapChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--p-h2color-color");

    this.options = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            color: textColor,
          },
        },
      },
    };
    this.data = {
      labels: this.GetBacDashboardLabels(),
      datasets: [
        {
          data: this.GetBacDashboardData(),
          backgroundColor: this.GetRandomColors(),
          hoverBackgroundColor: this.GetRandomColors(),
        },
      ],
    };
    this.cd.markForCheck();
  }

  ngOnChanges(): void {
    this.mapChart();
  }

  GetBacDashboardLabels() {
    const titles = this.bacDashboardInformation
      .filter(x => x.isActive)
      .map(item => {
        return `${item.supportBreakDown} (${item.supportPercentage}% / ${
          (8 * item.supportPercentage) / 100
        }Hrs)`;
      });
    return titles;
  }

  GetBacDashboardData() {
    const data = this.bacDashboardInformation
      .filter(x => x.isActive)
      .map(item => {
        return item.supportPercentage;
      });
    return data;
  }

  // GetRandomColors() {
  //   const data = this.bacDashboardInformation.map((item) => {
  //     return (
  //       '#' + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6)
  //     );
  //   });
  //   return data;
  // }

  GetRandomColors() {
    const fixedColors = [
      "#FFD1DC",
      "#E2C2E2",
      "#AED9E0",
      "#A4D4A6",
      "#FFF2A6",
      "#FFD8B1",
      "#D3A4F1",
      "#A4E8E0",
      "#E0D4A4",
      "#C7C7C7",
      "#FFB6B6",
      "#D0A0D0",
      "#B3E0E6",
      "#B2DBA1",
      "#FFE38A",
      "#FFC5A5",
      "#C395E2",
      "#B1ECE9",
      "#E4DDB2",
      "#CDCDCD",
      "#FFA6A6",
      "#C1B6E1",
      "#C2C2E2",
      "#C4E1A3",
      "#FFF3B1",
      "#FFA869",
      "#AE81AE",
      "#A3E8E1",
      "#E2D5B4",
      "#B4B4B4",
    ];

    return this.bacDashboardInformation.map((item, index) => {
      const colorIndex = index % fixedColors.length;
      return fixedColors[colorIndex];
    });
  }
  isDarkTheme(): boolean {
    return localStorage.getItem("theme") === "dark";
  }
}
